import {IoIosArrowDown, IoIosMenu} from "react-icons/io";
import {useEffect, useState} from "react";
import {NavLink} from "react-router";
import Dropdown from "../components/Dropdown";


export default function Navigation() {
    const [showNav, setShowNav] = useState(false);
    const [show, setShow] = useState(false)
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const controlNavbar = () => {
            if (window.scrollY > lastScrollY) {
                setShow(false);
            } else {
                setShow(true);
            }

            setLastScrollY(window.scrollY);
        }

        window.addEventListener('scroll', controlNavbar)
        return () => {
            window.removeEventListener('scroll', controlNavbar)
        }
    }, [lastScrollY]);

    return (
        <>
            <nav className={`bg-white ${show && "sticky top-0 z-[9999]"}`}>
                <div
                    className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4 border-b-2 border-blue-700">
                    <NavLink to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                        <img src="logo192.png" className="h-8" alt="Valuations Logo"/>
                        <span
                            className="self-center text-2xl font-semibold whitespace-nowrap text-black">ValuationsAfrica</span>
                    </NavLink>
                    <button onClick={() => setShowNav(s => !s)}
                            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200">
                        <IoIosMenu className={'text-2xl font-bold'}/>
                    </button>


                    <div className={`w-full md:block md:w-auto ${showNav ? "" : "hidden"}`}>
                        <ul className="flex flex-col font-medium p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white">
                            <li>
                                <NavLink to="/"
                                         className="block py-2 px-3 rounded md:bg-transparent text-center md:text-left md:p-0 font-semibold">Home</NavLink>
                            </li>
                            <li className={"hidden md:block"}>
                                <Dropdown>
                                    <Dropdown.Trigger
                                        className="flex items-center gap-2 text-center md:text-left hover:text-blue-700 font-semibold">
                                        About Us
                                        <IoIosArrowDown/>
                                    </Dropdown.Trigger>

                                    <Dropdown.Content className="px-3">
                                        <ul className="py-2 text-sm text-gray-700 ">
                                            <li>
                                                <NavLink to="/about"
                                                         className="block px-4 py-2 hover:bg-gray-100 font-semibold">Company
                                                    Profile</NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/blog"
                                                         className="block px-4 py-2 hover:bg-gray-100 font-semibold">Blog</NavLink>
                                            </li>
                                        </ul>
                                    </Dropdown.Content>
                                </Dropdown>
                            </li>

                            <li className={"block md:hidden"}>
                                <NavLink to="/about"
                                         className="block py-2 px-3 text-center md:text-left text-gray-900 rounded font-semibold hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0">
                                    Company Profile
                                </NavLink>
                            </li>
                            <li className={"block md:hidden"}>
                                <NavLink to="/blog"
                                         className="block py-2 px-3 text-center md:text-left text-gray-900 rounded font-semibold hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0">
                                    Blog
                                </NavLink>
                            </li>

                            <li>
                                <NavLink to="/services"
                                         className="block py-2 px-3 text-center md:text-left text-gray-900 rounded font-semibold hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0">Services</NavLink>
                            </li>
                            <li>
                                <NavLink to="/contact"
                                         className="block py-2 px-3 text-center md:text-left text-gray-900 rounded font-semibold hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0">Contact
                                    Us</NavLink>
                            </li>
                            <li>
                                <a href="https://staging.valuationsafrica.mw/register" target={"_blank"} rel="noreferrer"
                                   className="block py-2 px-3 text-center md:text-left text-gray-900 rounded font-semibold hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0">Sign Up</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className={`fixed inset-0 bg-gray-900 bg-opacity-20 z-[999] md:hidden ${showNav ? "" : "hidden"}`}
                 onClick={() => setShowNav(false)}></div>
        </>


    )
}